<template>
  <div
    class="notification-text"
    :class="[
      backgroundColor ? 'notification-text--background-color-' + backgroundColor : '',
      color ? 'notification-text--color-' + color : '',
      { 'notification-text--redesign': redesign },
    ]"
  >
    <fn-icon
      v-if="icon"
      :icon="icon"
      :color="iconColor"
      :size="iconSize"
    />
    <p v-html="text" />
  </div>
</template>

<script>
export default defineComponent({
  props: {
    icon: {
      type: [Array, String],
      default: '',
    },
    iconColor: {
      type: String,
      default: null,
    },
    iconSize: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: null,
    },
    backgroundColor: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      required: true,
    },
    redesign: {
      type: Boolean,
    },
  },
});
</script>

<style lang="scss" scoped>
.notification-text {
  display: flex;
  padding: $pad;
  margin-bottom: $pad;
  border-radius: map-get($border-radiuses, 'l');
  background-color: $color-general-background-neutral-default;

  &:last-child {
    margin-bottom: 0;
  }

  &.notification-text--redesign {
    align-items: center;
    border-radius: map-get($border-radiuses, xl);
    padding: $pad;

    p {
      color: $color-general-text-status-neutral-default;
      @include bp(m) {
        font-size: map-get($font-sizes, l);
      }
    }
  }

  @include bp(m) {
    padding: $pad $pad * 2;
  }

  .icon {
    margin-right: 10px;
    line-height: 19px;
  }

  p {
    margin-bottom: 0;
    font-size: map-get($font-sizes, 'm');
    line-height: 20px;
  }

  @each $palette, $tones in $palettes {
    @each $tone, $hex in $tones {
      @if $tone == 'base' {
        &.notification-text--color-#{$palette} {
          color: $hex;
        }
        &.notification-text--background-color-#{$palette} {
          background-color: $hex;
        }
      } @else {
        &.notification-text--color-#{$palette}-#{$tone} {
          color: $hex;
        }
        &.notification-text--background-color-#{$palette}-#{$tone} {
          background-color: $hex;
        }
      }
    }
  }
}
</style>
